import React, { type MouseEvent, useState } from 'react';

import { AddOutlined, ExpandMoreOutlined, HelpOutlineOutlined } from '@mui/icons-material';
import {
  Box,
  Button,
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';

import { useScenariosMutator } from '../../../hooks';

import AddScenarioDialog from './AddScenarioDialog';
import CurrentScenarioName from './CurrentScenarioName';
import EditCurrentScenarioButton from './EditCurrentScenarioButton';
import { CustomScenarioMenuItem, DefaultScenarioMenuItem } from './ScenarioMenuItem';

export default function ScenarioSelection() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const scenarios = useScenariosMutator();

  const [dialogOpen, setDialogOpen] = useState(false);

  const menuOpen = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Stack justifyContent="space-between" alignItems="center" direction="row" spacing={1} flexWrap="nowrap">
        <Box>
          <Button
            variant="outlined"
            size="small"
            onClick={handleClick}
            endIcon={<ExpandMoreOutlined />}
            sx={{ maxWidth: 256 }}
          >
            <Typography variant="body2" fontWeight="medium" noWrap>
              Scenario: <CurrentScenarioName />
            </Typography>
          </Button>
          <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleClose} MenuListProps={{ sx: { minWidth: 256 } }}>
            <DefaultScenarioMenuItem />
            {scenarios.map((name) => (
              <CustomScenarioMenuItem key={name} name={name} />
            ))}
            <Divider />
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                setDialogOpen(true);
              }}
            >
              <ListItemIcon>
                <AddOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText>Add scenario</ListItemText>
            </MenuItem>
          </Menu>
        </Box>
        <Stack spacing={1} flexShrink="0" direction="row" alignItems="center">
          <EditCurrentScenarioButton />
          <Tooltip title="Data scenarios allow you to use test different data payloads with your template.">
            <HelpOutlineOutlined sx={{ color: 'grey.600' }} fontSize="small" />
          </Tooltip>
        </Stack>
      </Stack>

      <AddScenarioDialog open={dialogOpen} closeDialog={() => setDialogOpen(false)} />
    </>
  );
}
